import React from 'react'
import PageMeta from '../components/PageMeta'
import ContactForm from '../components/ContactForm'
import { PAGES_DATA, COMPANY_INFO } from '../data/pagesData'

export default function KontaktPage() {
  const page = PAGES_DATA.kontakt

  return (
    <div>
      <PageMeta title={page.title} description={page.metaDescription} />

      {/* Main Contact Section matching Reference Design */}
      <section className="bg-white py-16 px-4 sm:px-8 min-h-[70vh] flex items-center">
        <div className="max-w-[1600px] mx-auto w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          {/* Left Column: Contact Information */}
          <div className="lg:col-span-5 space-y-6">
            <p className="text-xs font-bold uppercase tracking-wider text-[#02344A]">
              Kør trygt videre med vores hjælp
            </p>

            <h1 className="text-3xl sm:text-4xl font-black uppercase text-[#0A0A0A] tracking-tight">
              Kontakt os
            </h1>

            <div className="pt-4 space-y-4">
              <h2 className="text-xl sm:text-2xl font-bold uppercase text-[#0A0A0A]">
                Vores kontaktinformationer
              </h2>

              <div className="space-y-1 text-sm text-[#475569]">
                <p className="font-bold text-[#0A0A0A]">{COMPANY_INFO.name}</p>
                <p>
                  Adresse:{' '}
                  <a
                    href={COMPANY_INFO.mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0C63A4] font-semibold hover:underline"
                  >
                    {COMPANY_INFO.fullAddress}
                  </a>
                </p>
              </div>

              <div className="space-y-1 text-sm text-[#475569] pt-2">
                <p>
                  Telefon:{' '}
                  <a
                    href={`tel:${COMPANY_INFO.phoneRaw}`}
                    className="text-[#0C63A4] font-bold hover:underline"
                  >
                    {COMPANY_INFO.phone}
                  </a>
                </p>
                <p>
                  E-mail:{' '}
                  <a
                    href={`mailto:${COMPANY_INFO.email}`}
                    className="text-[#0C63A4] font-bold hover:underline"
                  >
                    {COMPANY_INFO.email}
                  </a>
                </p>
              </div>

              <p className="text-xs text-[#64748B] pt-4">
                CVR nr.: {COMPANY_INFO.cvr}
              </p>
            </div>
          </div>

          {/* Right Column: Dark Form Card */}
          <div className="lg:col-span-7">
            <div className="bg-[#02344A] rounded-2xl p-8 md:p-10 shadow-2xl shadow-[#02344A]/30">
              
              {/* Header & Divider */}
              <div className="border-b border-white/10 pb-6 mb-6 space-y-3">
                <h3 className="text-xl font-bold uppercase text-white leading-snug">
                  Har du spørgsmål eller ønsker du et uforpligtende tilbud?
                </h3>
                <p className="text-xs text-white/80 leading-relaxed">
                  Kontakt os allerede i dag for kompetent sparring og rådgivning ved din opgave.
                </p>
              </div>

              {/* Contact Form */}
              <ContactForm variant="dark" />

            </div>
          </div>

        </div>
      </section>
    </div>
  )
}
